export default function Footer() {
  return (
    <footer id="footer" className="bg-background-100 border-t border-background-200">
      <div className="max-w-screen-2xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div className="lg:col-span-1">
            <h3
              className="text-xl font-heading text-primary-500 mb-3"
              style={{ fontFamily: 'var(--font-heading)' }}
            >
              今日大瓜
            </h3>
            <p className="text-sm text-foreground-500 leading-relaxed">
              今日大瓜网是领先的娱乐吃瓜资讯聚合平台，每日更新最新吃瓜大瓜和娱乐吃瓜热点资讯。提供多源核验的吃瓜合集内容，满足你的吃瓜需求。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-bold text-foreground-800 mb-4 whitespace-nowrap">吃瓜专题</h4>
            <ul className="space-y-2">
              {['影视吃瓜', '综艺吃瓜', '明星动态', '恋情曝光', '争议事件'].map((item) => (
                <li key={item}>
                  <a href="#index" className="text-sm text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer no-underline whitespace-nowrap">{item}</a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-bold text-foreground-800 mb-4 whitespace-nowrap">快速导航</h4>
            <ul className="space-y-2">
              {[
                { label: '吃瓜热度榜', href: '#ranking' },
                { label: '最新快讯', href: '#updates' },
                { label: '吃瓜现场', href: '#media' },
                { label: '投稿爆料', href: '#contact' },
                { label: '关于我们', href: '#about' },
              ].map((item) => (
                <li key={item.href}>
                  <a href={item.href} className="text-sm text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer no-underline whitespace-nowrap">{item.label}</a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-bold text-foreground-800 mb-4 whitespace-nowrap">合作伙伴</h4>
            <p className="text-sm text-foreground-400">合作信息陆续开放中</p>
          </div>
        </div>

        <div className="border-t border-background-200 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-400">
            &copy; 2026 今日大瓜网 - 娱乐吃瓜热点资讯平台
          </p>
          <div className="flex items-center gap-4">
            <a href="#hero" className="text-xs text-foreground-400 hover:text-primary-500 transition-colors cursor-pointer no-underline whitespace-nowrap">回到顶部</a>
            <a href="#faq" className="text-xs text-foreground-400 hover:text-primary-500 transition-colors cursor-pointer no-underline whitespace-nowrap">常见问题</a>
            <a href="#contact" className="text-xs text-foreground-400 hover:text-primary-500 transition-colors cursor-pointer no-underline whitespace-nowrap">联系我们</a>
          </div>
        </div>
      </div>
    </footer>
  );
}